<template>
  <div class="body">
    <div class="main_container">
      <training-header :appConfig="appConfig"></training-header>
      <div class="right_col" role="main" style="margin-left: 0;">
        <br />
        <div class="row px-4 pt-2">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="x_panel qestion_page" v-if="traingUser">
              <div class="x_title">
                <h2 class="col-6">Certified Solutions Expert Exam</h2>
                <h2 class="examid col-6 text-right">EXAM ID NO: {{traingUser.examDetails.examId}}</h2>
                <div class="circle-wrap hide">
                  <div class="circlediv">
                    <h3>
                      0%
                      <br />
                      <span>Score</span>
                    </h3>
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>
              <div class="x_content" style="margin-top: 3%;">
                <div class="dashboard-widget-content">
                  <question v-if="questionObj" :questionObj="questionObj" @answer="getAnswer" :index="index" ></question>
                  <div class="row px-4">
                    <div class="col-md-6">
                      <div class="question_number_container">
                        <template v-for="(item, i) in quesLen" >
                          <div :class="{ 'active': i === index }" :key="i"><span>{{item}}</span></div>
                        </template>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="button-div" style="padding-top: 5%; padding-bottom: 5%;">
                        <a href="#" class="btn btn-primary" role="button" v-if="index+1 == questionArr.length" @click="submitResponse" style="padding: 6px 40px;">Submit</a>
                        <a href="#" class="btn btn-secondary" role="button" v-else @click="getQuestion" style="padding: 6px 40px;">Next</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /page content -->

      <!-- footer content -->
      <training-footer :appConfig="appConfig"></training-footer>
      <!-- /footer content -->
    </div>
  </div>
</template>
<script>
import trainingHeader from "../components/trainingHeader";
import trainingFooter from "../components/trainingFooter";
import question from "./question";
import ApiServices from '../service/ApiServices';
import swal from 'sweetalert2';
window.Swal = swal;
export default {
  components: {
    trainingHeader,
    trainingFooter,
    question
  },
  data(){
    return {
      facilitatorObj:{},
      appConfig:{},
      qData:[],
      traingUser: null,
      questionArr: [],
      quesLen: [],
      index: 0,
      questionObj: null,
      answer: null,
      answerArr: [],
      startTime: new Date().toLocaleString(),
      endTime: ''
    }
  },
  methods:{
    submitResponse(){
      localStorage.setItem("responseClick",'Submit');
      this.$root.loading = true;
      this.endTime = new Date().toLocaleString();
      let obj = {}
      obj.id = this.traingUser.id
      obj.email = this.traingUser.email
      obj.courseId = 54097
      
      obj.examDetails = {
        responseId: this.traingUser.examDetails.responseId,
        examId: this.traingUser.examDetails.examId,
        userId: this.traingUser.examDetails.userId,
        score: 0,
        userResponses: this.answerArr,
        endTime: this.endTime,
        startTime: this.startTime
      }
      let checkArr = []
      this.answerArr.forEach(key=>{
        if(key.optionId != null){
          checkArr.push(key.optionId)
        }
      })
      console.log(checkArr);
      if(checkArr.length > 0){
        ApiServices.RestPostCall('api/avenir/training/saveCourseExamResult',obj).then(res => {
          this.$root.loading = false;
          localStorage.setItem("score-board",JSON.stringify(res.examDetails));
          //this.$router.push("/score-board");
          this.$router.push({name: "score-board", params: {facilitatorObj: this.facilitatorObj,appConfig : this.appConfig}});
        }).catch((error) => {
          this.$root.loading = false;
          console.log(error)
        })
      }else{
        this.$root.loading = false;
        let temp = this
        //alert('Please attemp atleast one question')
        //Swal.fire('Any fool can use a computer')
        Swal.fire({
          text: "Please attemp atleast one question!",
          icon: 'warning',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33'
        }).then(function() {
          temp.index = 0
          window.location = "#/question-list";
        });
      }

    },
    getAnswer(value){
      console.log(value);
      this.answer = value
      let objIndex = this.answerArr.findIndex((obj => obj.questionId == value.questionId));
      if(objIndex != -1){
        this.answerArr[objIndex].optionId = value.optionId
      }else{
        this.answerArr.push(value)
      }
    },
    getQuestion(){
      this.index++
      this.questionObj = this.questionArr[this.index]
      localStorage.setItem("responseClick",'Next');
    },
    getQuestionList(){
      this.$root.loading = true;
      let obj = JSON.parse(localStorage.getItem("userDetails"));
      ApiServices.RestPostCall('api/avenir/training/addTrainingUser',obj).then(res => {
        this.$root.loading = false;
        this.traingUser = res.traingUser
        // this.traingUser.examDetails.questionTypes.forEach(key =>{
        //   key.masterQuestions.forEach(q =>{
        //     let question = {}
        //     question.id = q.questionId
        //     question.question = q.question
        //     question.options = q.options
        //     if(q.options != undefined){
        //       this.questionArr.push(question)
        //       this.answerArr.push({questionId: q.questionId, optionId: null})
        //     }
        //   })
        // })
        this.facilitatorObj = this.$route.params.facilitatorObj
        this.qData = this.facilitatorObj.course[0].questions
        this.qData.forEach(q =>{
          let question = {}
          question.id = q.questionId
          question.question = q.question
          question.options = q.options
          if(q.options != undefined){
            this.questionArr.push(question)
            this.answerArr.push({questionId: q.questionId, optionId: null})
          }
        })
        for(let i in this.questionArr){
          this.quesLen.push(Number(i)+1)
        }
        console.log(this.questionArr, this.quesLen)
        this.questionObj = this.questionArr[this.index]

        console.log(this.answerArr)
      }).catch((error) => {
        this.$root.loading = false;
        console.log(error)
      })
    }
  },
  mounted(){
    this.getQuestionList()
    if(this.$route.params.facilitatorObj){
      this.facilitatorObj = this.$route.params.facilitatorObj
      console.log(this.facilitatorObj);
    }
    if(this.$route.params.appConfig){
      this.appConfig = this.$route.params.appConfig
    }
  }
};
</script>
<style scoped>
.x_panel {
  background-color: #fff;
  border: 0px solid transparent;
  padding: 0;
  border-radius: 7px;
}
.x_title {
  border-bottom: 0px solid #e6e9ed;
  padding: 15px 18px;
  background-color: #b0b0b0;
  color: #fff;
  border-radius: 7px 7px 0 0;
}
.x_content {
  padding: 0 25px 6px;
}
.button-div {
  display: flex;
  justify-content: center;
  margin-bottom: 4%;
}
.active{
  border: 2px solid #3471ce;
  color: #3471ce !important;
}
</style>
